import { useEffect, useState } from "react";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import axiosInstance from "../../api/axiosInstance.js";
import { useLocation, useNavigate } from "react-router-dom";
import Model from "../../common/Model/index.js";
import { saveAs } from "file-saver";
import Loader from "../../common/Loader/index.js";
import { notify, Toast } from "../../common/Toast/index.js";
import Select from "react-select";
import { FaStarOfLife } from "react-icons/fa";
import FormFields from "../../common/FormFields/index.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";
import FinsMaterialItemTable from "./FinsMaterialItemTable.jsx";

const FinsMaterialDetails = () => {
  const today = new Date().toISOString()?.split("T")[0];
  const permission = getUserMenuPermission(18);
  const navigate = useNavigate();
  const location = useLocation();
  const { materialQuotationData = {} } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [terms, setTerms] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [salesPersons, setSalesPersons] = useState([]);
  const [coatingParties, setCoatingParties] = useState([]);
  const [coatingColors, setCoatingColors] = useState([]);
  const [coatingType, setCoatingType] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [allItems, setAllItems] = useState([]);
  const [isCoatingModalOpen, setIsCoatingModalOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [isItemModalOpen, setIsItemModalOpen] = useState(false);
  const [isSameAsBilling, setIsSameAsBilling] = useState(true);
  const [coatingPartyModel, setCoatingPartyModel] = useState(false);
  const [items, setItems] = useState([
    {
      seQ_NO: 1,
      itemId: "",
      item_Name: "",
      coating_Color_Id: "",
      panel_Size: 0,
      qty: 0,
      total_RFT: 0,
      rate: 0,
      coatingTypeId: 1,
      amount: 0,
    },
  ]);
  const [formData, setFormData] = useState({
    proforma_No: 0,
    proforma_Date: today,
    customer_Id: "",
    company_Id: 3,
    sale_Id: "",
    coating_Party_Id: "",
    shipping_Address: "",
    remark: "",
    project: "",
    gross_Amount: 0,
    disc_Per: 0,
    disc_Amount: 0,
    gsT_Per: 18,
    gsT_Amount: 0,
    transportation: 0,
    packing_Charge: 0,
    net_Amount: "",
    stageId: null,
    reason: "",
  });
  const [isCoatingPartyEditing, setIsCoatingPartyEditing] = useState(false);

  const userId = sessionStorage.getItem("userId");
  const shouldShowCloseLostReason = (stageId) => {
    return stageId === 3;
  };
  const fields = [
    {
      name: "customer_Name",
      label: "Customer Name",
      type: "text",
      required: true,
      errorMessage: "Customer name is required",
    },
    { name: "mobile_No", label: "Contact No", type: "number" },
    { name: "firmName", label: "FirmName", type: "text" },
    { name: "address", label: " Address", type: "text" },
    { name: "gsT_No", label: "GST No", type: "text" },
  ];
  const CoatingPartyfields = [
    {
      name: "party_Name",
      label: "Party Name",
      type: "text",
      required: true,
      errorMessage: "Party name is required",
    },
    { name: "mobile_No", label: "Contact No", type: "number" },
    { name: "address", label: "Address", type: "text" },
    { name: "gsT_No", label: "GST No", type: "text" },
  ];

  useEffect(() => {
    if (
      materialQuotationData &&
      Object.keys(materialQuotationData).length > 0
    ) {
      setFormData((prev) => ({
        ...prev,
        proforma_No: materialQuotationData.proforma_No || 0,
        proforma_Date: materialQuotationData.proforma_Date,
        customer_Id: materialQuotationData.customer_Id || "",
        company_Id: materialQuotationData.company_Id || 3,
        sale_Id: materialQuotationData.sale_Id || "",
        coating_Party_Id: materialQuotationData.coating_Party_Id || "",
        shipping_Address: materialQuotationData.shipping_Address || "",
        remark: materialQuotationData.remark || "",
        project: materialQuotationData.project || "",
        gross_Amount: materialQuotationData.gross_Amount || "",
        disc_Per: materialQuotationData.disc_Per || 0,
        disc_Amount: materialQuotationData.disc_Amount || 0,
        gsT_Per: materialQuotationData.gsT_Per || 0,
        gsT_Amount: materialQuotationData.gsT_Amount ?? 0,
        transportation: materialQuotationData.transportation || 0,
        packing_Charge: materialQuotationData.packing_Charge || 0,
        net_Amount: materialQuotationData.net_Amount || 0,
        stageId: materialQuotationData.stage_Id || 0,
        reason: materialQuotationData.reason ?? "",
      }));

      const mapped = materialQuotationData.items.map((it, index) => ({
        seQ_NO: it.seQ_NO || index + 1,

        itemId: it.itemId,
        item_Name: it.item_Name,
        coating_Color_Id: it.coating_Color_Id,
        coatingTypeId: it.coatingTypeId,

        panel_Size: it.panel_Size,
        qty: it.qty,

        baseRate: it.actualRate ?? it.rate,
        rate: Number(it.rate),
        total_RFT: Number(it.total_RFT),
        amount: Number(it.amount),
      }));

      setItems(mapped);

      // setItems(materialQuotationData.items || []);
      setTerms(materialQuotationData.terms || []);
      setIsEditing(true);
    }
  }, [materialQuotationData, allItems, coatingType]);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.customer_Id)
      newErrors.customer_Id = "Customer Name is required";
    if (!formData.sale_Id) newErrors.sale_Id = "Sale Person is required";
    if (!formData.proforma_Date)
      newErrors.proforma_Date = "Proforma Date is required";

    if (items.length === 0) {
      newErrors.items = "At least one item is required";
    } else {
      items.forEach((item, index) => {
        if (!item.itemId)
          newErrors[`item_Code_${index}`] = "Item Code is required";
        if (!item.qty || item.qty <= 0)
          newErrors[`qty_${index}`] = "Quantity must be greater than 0";
      });
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: name === "proforma_No" ? parseInt(value, 10) || 0 : value,
    }));
  };

  const handleCoatingPartySubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        Party_Name: formData.party_Name,
        Mobile_No: formData.mobile_No,
        Address: formData.address,
        GST_No: formData.gsT_No,
        Is_Active: formData.is_Active ?? true,
      };

      const response = await axiosInstance.post(
        "MaterialQuotation/SaveCoatingParty",
        payload
      );

      notify("Coating Party added successfully!", "success");
      fetchDropdownData("Coating/GetAllCoatingParties", setCoatingParties);
      if (response?.data?.coating_Party_Id) {
        setFormData((prev) => ({
          ...prev,
          coating_Party_Id: response.data.coating_Party_Id,
        }));
      }

      setCoatingPartyModel(false);
    } catch (err) {
      console.error("Error saving coating party:", err);
      notify("Failed to add Coating Party", "error");
    }
  };

  const handleCustomerChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData((prev) => ({
        ...prev,
        customer_Id: "",
        shipping_Address: "",
      }));
      setIsSameAsBilling(false);
      return;
    }

    const customerId = selectedOption.value;
    if (customerId === "add-new") {
      setFormData({
        customer_Name: "",
        mobile_No: "",
        firmName: "",
        address: "",
        gsT_No: "",
        customer_Id: "",
        shipping_Address: "",
      });
      setIsSameAsBilling(false);
      setIsModelOpen(true);
      return;
    }

    const customer = customers.find(
      (c) => c.customer_Id === Number(customerId)
    );
    const address = customer?.address || "";
    setFormData((prev) => ({
      ...prev,
      customer_Id: Number(customerId),
      shipping_Address: address,
    }));
    setIsSameAsBilling(true);
  };
  const handleSameAsBillingChange = () => {
    const selectedCustomer = customers.find(
      (c) => c.customer_Id === Number(formData.customer_Id)
    );

    const address = selectedCustomer?.address || "";

    setIsSameAsBilling((prev) => {
      const newValue = !prev;
      setFormData((prevForm) => ({
        ...prevForm,
        shipping_Address: newValue ? address : "",
      }));
      return newValue;
    });
  };

  useEffect(() => {
    fetchDropdownData("Customer/GetAll", setCustomers);
    fetchDropdownData("User/GetAllUser ", setSalesPersons);
    fetchDropdownData(
      "MaterialQuotation/GetAllCoatingParties",
      setCoatingParties
    );
    fetchDropdownData(
      "MaterialQuotation/GetAllCoatingColors",
      setCoatingColors
    );
    fetchDropdownData("CoatingType/GetAll", setCoatingType);
    fetchItemsData();
    if (
      materialQuotationData &&
      Object.keys(materialQuotationData).length > 0
    ) {
      fetchTermsData(
        materialQuotationData.proforma_No,
        materialQuotationData.terms
      );
    } else {
      fetchTermsData(0);
    }
  }, []);

  const fetchTermsData = async (proforma_No = 0, existingTerms = []) => {
    try {
      setLoading(true);

      if (proforma_No === 0) {
        const response = await axiosInstance.get("Terms/GetAll");
        const formattedTerms = response.data.map((term, index) => ({
          seq_No: index + 1,
          term_Name: term.term_Name,
          term_Id: term.term_Id,
          isEditing: false,
        }));
        setTerms(formattedTerms);
      } else {
        setTerms(existingTerms || []);
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchItemsData = async () => {
    try {
      const response = await axiosInstance.get("FinsItem/GetAll");
      setAllItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const totalAmountBeforeTax = items.reduce(
    (sum, item) => sum + (item.amount || 0),
    0
  );

  const discount =
    (Number(totalAmountBeforeTax) * (Number(formData.disc_Per) || 0)) / 100;

  const total =
    totalAmountBeforeTax -
    discount +
    formData.transportation +
    formData.packing_Charge;

  const gstAmount = (total * (Number(formData.gsT_Per) || 0)) / 100;

  const grandTotal = total + gstAmount;

  const num = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const calcRft = (row) => {
    const panel = num(row.panel_Size);
    const qty = num(row.qty);
    return panel > 0 ? (panel * qty) / 304.8 : qty;
  };

  const findItem = (all, id) =>
    all?.find((it) => String(it.itemId) === String(id));

  const getItemBaseRate = (all, id) => {
    const it = findItem(all, id);
    return num(it?.rate ?? it?.item_Rate);
  };

  const getAddPer = (coatingType, id) => {
    const t = coatingType?.find(
      (ct) => String(ct.coatingTypeId) === String(id)
    );
    return num(t?.addPer);
  };

  const calcFinalRate = (baseRate, coatingTypeId) => {
    const addPer = getAddPer(coatingType, coatingTypeId);
    return num(baseRate) * (1 + addPer / 100);
  };

  const round2 = (v) => Math.round(Number(v) * 100) / 100;

  const recalcRow = (row) => {
    const rftRaw = calcRft(row);
    const total_RFT = round2(rftRaw);
    const rate = Math.round(num(row.rate));
    const amount = round2(total_RFT * rate);

    return {
      ...row,
      total_RFT,
      rate,
      amount,
    };
  };

  const handleItemSelect = (index, eventOrOption, fieldName = null) => {
    const updated = [...items];

    const getValue = () =>
      eventOrOption?.target?.value !== undefined
        ? eventOrOption.target.value
        : eventOrOption?.value;

    const setField = (row, key, value) => ({ ...row, [key]: value });

    if (fieldName && eventOrOption === null) {
      if (fieldName === "itemId") {
        updated[index] = recalcRow({
          ...updated[index],
          itemId: "",
          item_Name: "",
          baseRate: 0,
          coatingTypeId: "",
          coating_Color_Id: "",
          rate: 0,
          qty: 0,
          panel_Size: 0,
          total_RFT: 0,
          amount: 0,
        });
        setItems(updated);
        return;
      }

      if (name === "coatingTypeId") {
        const base = num(updated[index].baseRate);
        const finalRate = calcFinalRate(base, value);

        updated[index] = recalcRow({
          ...updated[index],
          coatingTypeId: value,
          rate: Math.round(finalRate),
        });

        setItems(updated);
        return;
      }

      updated[index] = recalcRow(setField(updated[index], fieldName, ""));
      setItems(updated);
      return;
    }

    const value = fieldName ? getValue() : eventOrOption.target.value;
    const name = fieldName ? fieldName : eventOrOption.target.name;

    if (name === "coating_Color_Id" && value === "add-new") {
      if (!formData.coating_Party_Id) {
        notify(
          "Please select a Coating Party before adding a new Coating Color",
          "error"
        );
        return;
      }
      setIsCoatingModalOpen(true);
      return;
    }

    if (name === "itemId" && value === "add-newItem") {
      setIsItemModalOpen(true);
      return;
    }

    if (name === "itemId") {
      const selectedItem = findItem(allItems, value);
      if (!selectedItem) return;

      const base = num(selectedItem.rate ?? selectedItem.item_Rate);
      const coatingTypeId = updated[index].coatingTypeId;

      const finalRate = coatingTypeId
        ? calcFinalRate(base, coatingTypeId)
        : base;

      updated[index] = recalcRow({
        ...updated[index],
        itemId: selectedItem.itemId || "",
        item_Name: selectedItem.itemName || selectedItem.item_Name || "",
        baseRate: base,
        rate: finalRate,
      });

      setItems(updated);
      return;
    }

    if (name === "coatingTypeId") {
      const coatingTypeId = value || "";
      const base =
        num(updated[index].baseRate) ||
        getItemBaseRate(allItems, updated[index].itemId);

      const finalRate = coatingTypeId
        ? calcFinalRate(base, coatingTypeId)
        : base;

      updated[index] = recalcRow({
        ...updated[index],
        coatingTypeId,
        baseRate: base,
        rate: Math.round(finalRate),
      });

      setItems(updated);
      return;
    }

    if (name === "rate") {
      updated[index] = recalcRow({
        ...updated[index],
        rate: num(value),
      });
      setItems(updated);
      return;
    }

    updated[index] = recalcRow(setField(updated[index], name, value));

    setItems(updated);
  };

  const handleItemDelete = async (rowIndex) => {
    const proforma_No = Number(formData.proforma_No || 0);
    const row = items[rowIndex];
    const isPersisted = proforma_No > 0 && Number(row?.seQ_NO) > 0;
    if (isPersisted) {
      try {
        await axiosInstance.delete(
          `FinsMaterialQuotations/DeleteItem/${proforma_No}/${row.seQ_NO}`
        );
        notify("Item deleted successfully", "success");
      } catch (error) {
        console.error("Error deleting item:", error);
        notify(
          error?.response?.data?.message || "Error deleting item",
          "error"
        );
        return;
      }
    }
    setItems((prev) =>
      prev
        .filter((_, i) => i !== rowIndex)
        .map((it, i) => ({ ...it, seQ_NO: i + 1 }))
    );
  };

  const fetchDropdownData = async (endpoint, setData, dataKey) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(endpoint);
      if (dataKey) {
        setData(response.data[dataKey] || []);
      } else {
        setData(response.data || []);
      }
    } catch (error) {
      console.error(`Error fetching data from ${endpoint}:`, error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddTerm = () => {
    setTerms((prevTerms) => {
      if (formData.proforma_No === 0) {
        const newTermId =
          prevTerms.length > 0
            ? prevTerms[prevTerms.length - 1].term_Id + 1
            : 1;
        return [
          ...prevTerms,
          { term_Id: newTermId, term_Name: "", isEditing: true },
        ];
      } else {
        const newSeqNo =
          prevTerms.length > 0 ? prevTerms[prevTerms.length - 1].seq_No + 1 : 1;
        return [
          ...prevTerms,
          { seq_No: newSeqNo, term_Name: "", isEditing: true, isNew: true },
        ];
      }
    });
  };

  const handleEditTerms = (id) => {
    setTerms((prevTerms) =>
      prevTerms.map((term) =>
        (formData.proforma_No === 0 ? term.term_Id : term.seq_No) === id
          ? { ...term, isEditing: true }
          : term
      )
    );
  };
  const handleDeleteTerm = async (seq_No, isNew) => {
    const proforma_No = formData.proforma_No;
    if (proforma_No === 0) {
      setTerms((prevTerms) =>
        prevTerms.filter((term) => term.term_Id !== seq_No)
      );
    } else {
      if (isNew === true) {
        setTerms((prevTerms) =>
          prevTerms.filter((term) => term.seq_No !== seq_No)
        );
        return;
      }
      try {
        await axiosInstance.delete(
          `FinsMaterialQuotations/DeleteTerm/${proforma_No}/${seq_No}`
        );
        setTerms((prevTerms) =>
          prevTerms.filter((term) => term.seq_No !== seq_No)
        );
      } catch (error) {
        console.error("Error deleting term:", error);
      }
    }
  };

  const handleTermChange = (index, event) => {
    const { name, value } = event.target;
    setTerms((prevTerms) =>
      prevTerms.map((term, i) =>
        i === index ? { ...term, [name]: value } : term
      )
    );
  };

  const handleSaveOrUpdate = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }
    const payload = {
      Proforma_No: Number(formData.proforma_No) || 0,
      Customer_Id: Number(formData.customer_Id),
      Company_Id: formData.company_Id || 3,
      Sale_Id: Number(formData.sale_Id),
      Coating_Party_Id: Number(formData.coating_Party_Id),
      shipping_Address: formData.shipping_Address,
      remark: formData.remark,
      project: formData.project,
      Proforma_Date: formData.proforma_Date,
      Modified_By: Number(formData.modifiedBy) || 0,
      Gross_Amount: Number(totalAmountBeforeTax),
      Disc_Per: Number(formData.disc_Per),
      Disc_Amount: Number(discount),
      GST_Per: Number(formData.gsT_Per),
      GST_Amount: Number(gstAmount),
      Transportation: Number(formData.transportation),
      Packing_Charge: Number(formData.packing_Charge),
      Net_Amount: Number(grandTotal),
      CreatedBy: userId,
      ...(Number(formData.stageId) === 3 && {
        Reason: formData.reason,
      }),

      Items: items.map((item) => ({
        itemId: Number(item.itemId),
        Coating_Color_Id:
          item.coating_Color_Id && !isNaN(item.coating_Color_Id)
            ? parseInt(item.coating_Color_Id)
            : null,
        Qty: Number(item.qty) || 0,
        Panel_size: item.panel_Size || 0,
        coatingTypeId: item.coatingTypeId,
        total_RFT: Number(item.total_RFT),
        Rate: Number(item.rate),
        Amount: item.amount,
        seQ_NO: item.seQ_NO,
      })),
      Terms: terms.map((term) => ({
        seq_No: Number(formData.proforma_No) > 0 ? Number(term.seq_No) : 0,
        Term_Name: term.term_Name,
        Proforma_No: Number(formData.proforma_No),
      })),
    };

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "FinsMaterialQuotations/SaveOrUpdate",
        payload
      );

      if (response?.data) {
        notify(
          isEditing
            ? "Fins Quotation updated successfully!"
            : "Fins Quotation added successfully!",
          "success"
        );
        setTimeout(() => navigate("/quotes/fins-quotation"), 1000);
      } else {
        notify("Something went wrong. Please try again.", "error");
      }
    } catch (error) {
      console.error("Error saving quotation:", error);
      notify("Failed to save Fins Quotation.", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        Customer_Name: formData.customer_Name,
        Firm_Name: formData.firmName,
        Mobile_No: formData.mobile_No,
        Address: formData.address,
        GST_No: formData.gsT_No,
      };

      await axiosInstance.post("Customer/SaveOrUpdate", payload);
      fetchDropdownData("Customer/GetAll", setCustomers);
      setIsModelOpen(false);
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };

  const onClear = () => {
    setIsModelOpen(false);
  };

  const handlePrint = async (proforma_No) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `FinsMaterialQuotations/FinsQuotePrint/${proforma_No}`,
        { responseType: "blob" }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], { type: "application/pdf" });

        const customer = customers.find(
          (c) => c.customer_Id === Number(formData.customer_Id)
        );
        const customerName =
          customer?.customer_Name?.replace(/\s+/g, "_") || "Customer";

        saveAs(blob, `PI_${proforma_No}_${customerName}.pdf`);

        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
      } else {
        alert("Failed to generate PDF. Please try again later.");
      }
    } catch (error) {
      console.error("Error printing Fins Quotation:", error);
      const errorMessage =
        error.response?.data?.message || "Unknown error occurred.";

      if (errorMessage.includes("Select.HtmlToPdf")) {
        alert(
          "PDF generation is currently unavailable. Please contact support."
        );
      } else {
        alert(`An error occurred while printing: ${errorMessage}`);
      }
    } finally {
      setLoading(false);
    }
  };

  const options = [
    ...customers.map((cus) => ({
      value: cus.customer_Id?.toString() || "",
      label: cus.customer_Name || "Unnamed Customer",
    })),
    { value: "add-new", label: "+ Add New Customer" },
  ];
  const saleOptions = [
    ...salesPersons.map((per) => ({
      value: per.sale_Person_Id?.toString() || "",
      label: per.Sale_Person_Name || "Unnamed Sales",
    })),
  ];
  const coatingOptions = [
    ...coatingParties.map((coat) => ({
      value: coat.coating_Party_Id?.toString() || "",
      label: coat.party_Name || "Unnamed Coating",
    })),
    { value: "add-newCoatingParty", label: "+ Add New Coating Party" },
  ];

  const handleCoatingPartyEdit = async (id) => {
    try {
      const { data } = await axiosInstance.get(
        `MaterialQuotation/GetCoatingPartyById/${id}`
      );
      setFormData((prev) => ({
        ...prev,
        ...data,
        coating_Party_Id: Number(id),
      }));
      setIsCoatingPartyEditing(true);
      setCoatingPartyModel(true);
    } catch (err) {
      console.error(err);
    }
  };
  const handleUpdateCoatingParty = async () => {
    try {
      await axiosInstance.post("MaterialQuotation/UpdateCoatingParty", {
        Coating_Party_Id: formData.coating_Party_Id,
        Party_Name: formData.party_Name,
        Mobile_No: formData.mobile_No,
        Address: formData.address,
        Gst_No: formData.gsT_No,
      });

      notify("Coating Party Updated Successfully!", "success");
      fetchDropdownData("Coating/GetAllCoatingParties", setCoatingParties);
      setCoatingPartyModel(false);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <Toast />
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5">
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
              <h1 className="text-lg font-bold">Fins Details</h1>
              <button
                className="px-6 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-secondary"
                onClick={() => navigate(`/quotes/fins-quotation`)}
              >
                Back
              </button>
            </div>
            <form onSubmit={handleSaveOrUpdate}>
              <div className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white rounded-lg shadow-md p-6 p-6 border-4 border-[#f1f4f9] rounded-lg shadow-md">
                  <div className="relative">
                    <label className="flex items-center text-sm font-medium mb-2">
                      Customer
                      <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                    </label>
                    <Select
                      options={options}
                      value={
                        formData.customer_Id
                          ? options.find(
                              (option) =>
                                Number(option.value) ===
                                Number(formData.customer_Id)
                            ) || null
                          : null
                      }
                      isClearable
                      isSearchable
                      onChange={handleCustomerChange}
                      className="mt-1"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          borderColor: errors.customer_Id
                            ? "#ef4444"
                            : "#e5e7eb",
                          boxShadow: "none",
                          "&:hover": { borderColor: "gray" },
                        }),
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: "300px",
                          overflowY: "auto",
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: "300px",
                          overflowY: "auto",
                        }),
                        option: (provided, { data }) => ({
                          ...provided,
                          backgroundColor:
                            data.value === "add-new"
                              ? "#F3F4F6"
                              : provided.backgroundColor,
                          fontWeight:
                            data.value === "add-new" ? "bold" : "normal",
                          cursor: "pointer",
                          position:
                            data.value === "add-new" ? "sticky" : "relative",
                          bottom: data.value === "add-new" ? "0" : "auto",
                        }),
                      }}
                    />
                    {errors.customer_Id && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.customer_Id}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="flex items-center text-sm font-medium mb-2">
                      Company
                    </label>
                    <input
                      type="text"
                      value="H-LINE"
                      disabled
                      name="company_Id"
                      className="mt-1 block w-full rounded-md border border-gray shadow-sm py-2 px-3"
                    />
                  </div>
                  <div>
                    <label className="flex items-center text-sm font-medium mb-2">
                      Sales Person
                      <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                    </label>
                    <Select
                      options={saleOptions}
                      value={
                        formData.sale_Id
                          ? saleOptions.find(
                              (option) =>
                                Number(option.value) ===
                                Number(formData.sale_Id)
                            ) || null
                          : null
                      }
                      isClearable
                      isSearchable
                      onChange={(selectedOption) =>
                        setFormData((prev) => ({
                          ...prev,
                          sale_Id: selectedOption ? selectedOption.value : "",
                        }))
                      }
                      className="mt-1"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          borderColor: errors.sale_Id ? "#ef4444" : "#e5e7eb",
                          boxShadow: "none",
                          "&:hover": { borderColor: "gray" },
                        }),
                        menu: (provided) => ({
                          ...provided,
                          maxHeight: "300px",
                          overflowY: "auto",
                        }),
                        menuList: (provided) => ({
                          ...provided,
                          maxHeight: "300px",
                          overflowY: "auto",
                        }),
                      }}
                    />
                    {errors.sale_Id && (
                      <p className="text-red-500 text-xs mt-1">
                        {errors.sale_Id}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-md font-medium mb-1 ">
                      Coating Party
                    </label>
                    <div className="flex gap-2 items-center">
                      <div className="w-full">
                        <Select
                          options={coatingOptions}
                          value={
                            formData.coating_Party_Id
                              ? coatingOptions.find(
                                  (option) =>
                                    Number(option.value) ===
                                    Number(formData.coating_Party_Id)
                                ) || null
                              : null
                          }
                          isClearable
                          isSearchable
                          onChange={(selectedOption) => {
                            if (
                              selectedOption?.value === "add-newCoatingParty"
                            ) {
                              setFormData({
                                party_Name: "",
                                mobile_No: "",
                                address: "",
                                gsT_No: "",
                              });
                              setCoatingPartyModel(true);
                            } else {
                              setFormData((prev) => ({
                                ...prev,
                                coating_Party_Id: selectedOption
                                  ? selectedOption.value
                                  : "",
                              }));
                            }
                          }}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              borderColor: errors.customer_Id
                                ? "#ef4444"
                                : "#e5e7eb",
                              boxShadow: "none",
                              "&:hover": { borderColor: "gray" },
                            }),
                            menu: (provided) => ({
                              ...provided,
                              maxHeight: "300px",
                              overflowY: "auto",
                            }),
                            menuList: (provided) => ({
                              ...provided,
                              maxHeight: "300px",
                              overflowY: "auto",
                            }),
                            option: (provided, { data }) => ({
                              ...provided,
                              backgroundColor:
                                data.value === "add-newCoatingParty"
                                  ? "#F3F4F6"
                                  : provided.backgroundColor,
                              fontWeight:
                                data.value === "add-newCoatingParty"
                                  ? "bold"
                                  : "normal",
                              cursor: "pointer",
                              position:
                                data.value === "add-newCoatingParty"
                                  ? "sticky"
                                  : "relative",
                              bottom:
                                data.value === "add-newCoatingParty"
                                  ? "0"
                                  : "auto",
                            }),
                          }}
                        />
                      </div>

                      {formData.coating_Party_Id && (
                        <button
                          type="button"
                          className="text-primary bg-primary/10 hover:bg-primary/20 rounded-md p-2"
                          onClick={() =>
                            handleCoatingPartyEdit(formData.coating_Party_Id)
                          }
                        >
                          <MdModeEdit />
                        </button>
                      )}
                    </div>
                  </div>
                  <div>
                    <label className="flex items-center text-sm font-medium mb-2">
                      Project
                    </label>
                    <input
                      type="text"
                      value={formData.project}
                      onChange={handleInputChange}
                      name="project"
                      className="mt-1 block w-full rounded-md border border-gray shadow-sm py-2 px-3 focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                    />
                  </div>
                </div>
                <div className="bg-white shadow-md p-6 space-y-6 p-6 border-4 border-[#f1f4f9] rounded-lg shadow-md">
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      className="w-4 h-4 text-primary border-gray rounded focus:ring-primary bg-primary"
                      checked={isSameAsBilling}
                      onChange={handleSameAsBillingChange}
                    />
                    <label className="text-sm font-medium ">
                      Same as Billing Address
                    </label>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-md font-medium mb-1 ">
                        Shipping Address
                      </label>
                      <textarea
                        rows={4}
                        className="mt-4 block w-full rounded border px-4 py-2 shadow-sm focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                        value={formData.shipping_Address}
                        onChange={(e) => {
                          const value = e.target.value;
                          setFormData((prev) => ({
                            ...prev,
                            shipping_Address: value,
                          }));
                          setIsSameAsBilling(false);
                        }}
                        disabled={isSameAsBilling}
                      />
                    </div>
                    <div className="space-y-4">
                      <div>
                        <label className="block text-md font-medium mb-1 ">
                          Proforma No
                        </label>
                        <input
                          type="text"
                          className="w-full rounded-md border border-gray shadow-sm py-2 px-3"
                          name="proforma_No"
                          value={formData.proforma_No}
                          onChange={handleInputChange}
                          disabled
                        />
                      </div>
                      <div className="relative">
                        <label className="flex items-center text-sm font-medium mb-1">
                          Proforma Date
                          <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
                        </label>
                        <input
                          type="date"
                          className={`w-full border rounded p-2 ${
                            errors.proforma_Date
                              ? "border-red-500"
                              : "border-gray-300"
                          }`}
                          name="proforma_Date"
                          value={formData.proforma_Date?.split("T")[0]}
                          onChange={handleInputChange}
                          onFocus={(e) => e.target.showPicker()}
                        />
                        {errors.proforma_Date && (
                          <p className="text-red-500 text-xs mt-1">
                            {errors.proforma_Date}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <FinsMaterialItemTable
                items={items}
                setItems={setItems}
                allItems={allItems}
                setAllItems={setAllItems}
                coatingColors={coatingColors}
                setCoatingColors={setCoatingColors}
                setCoatingType={setCoatingType}
                coatingType={coatingType}
                handleItemSelect={handleItemSelect}
                handleItemDelete={handleItemDelete}
                selectedCoatingPartyId={formData.coating_Party_Id}
                isCoatingModalOpen={isCoatingModalOpen}
                setIsCoatingModalOpen={setIsCoatingModalOpen}
                setIsItemModalOpen={setIsItemModalOpen}
                isItemModalOpen={isItemModalOpen}
                errors={errors}
                validateForm={validateForm}
                isEditing={isEditing}
                fetchDropdownData={fetchDropdownData}
                permission={permission}
              />
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                <div className="bg-white rounded-lg shadow-md h-full">
                  <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                    <h2 className="text-base font-semibold text-[#405189]">
                      Terms List
                    </h2>
                  </div>
                  <div className="max-h-[350px] overflow-y-auto px-4 py-3 space-y-3">
                    {terms.map((term, index) => (
                      <div
                        key={index}
                        className="flex items-center border p-2 space-x-3"
                      >
                        <input
                          type="text"
                          name="term_Name"
                          value={term.term_Name || ""}
                          onChange={(e) => handleTermChange(index, e)}
                          disabled={!term.isEditing}
                          className="flex-grow px-2 py-1 rounded border border-gray-300 focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                        />
                        <div className="flex space-x-2">
                          <button
                            type="button"
                            className="text-success"
                            onClick={() =>
                              handleEditTerms(
                                formData.proforma_No === 0
                                  ? term.term_Id
                                  : term.seq_No
                              )
                            }
                          >
                            <MdModeEdit className="w-8 h-8 bg-green-100 p-1 rounded-md hover:bg-green-200 focus:outline-none focus:ring-2 focus:ring-red-500" />
                          </button>
                          <button
                            type="button"
                            onClick={() =>
                              handleDeleteTerm(
                                formData.proforma_No === 0
                                  ? term.term_Id
                                  : term.seq_No,
                                term.isNew
                              )
                            }
                            className="text-danger"
                          >
                            <MdDeleteForever className="text-danger w-8 h-8 bg-red-100 p-1 rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="p-4">
                    <button
                      type="button"
                      className="bg-secondary text-white px-4 py-2 rounded-md"
                      onClick={handleAddTerm}
                    >
                      + Add Terms
                    </button>
                  </div>
                </div>

                <div className="bg-white rounded-lg shadow-md">
                  <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                    <h2 className="text-base font-semibold text-[#405189]">
                      Account List
                    </h2>
                  </div>
                  <div className="space-y-4 p-6 ">
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 font-medium">
                        Total Amount Before Tax:
                      </span>
                      <strong className="text-lg">
                        ₹{totalAmountBeforeTax?.toFixed(2)}
                      </strong>
                    </div>

                    <div className="flex justify-between items-center">
                      <label
                        className="text-gray-700 font-medium"
                        htmlFor="disc_Per"
                      >
                        Discount (%):
                      </label>
                      <div className="flex items-center space-x-2">
                        <input
                          type="text"
                          id="disc_Per"
                          name="disc_Per"
                          value={formData.disc_Per}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              disc_Per: Number(e.target.value) || 0,
                            }))
                          }
                          className="border rounded-md px-2 py-1 w-24 text-right focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                        />
                        <span>= ₹{discount?.toFixed(2)}</span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <label
                        className="text-gray-700 font-medium"
                        htmlFor="transportation"
                      >
                        Transportation:
                      </label>
                      <input
                        type="text"
                        id="transportation"
                        name="transportation"
                        value={formData.transportation}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            transportation: Number(e.target.value),
                          }))
                        }
                        className="border rounded-md px-2 py-1 w-24 text-right focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <label
                        className="text-gray-700 font-medium"
                        htmlFor="packing_Charge"
                      >
                        Packing Charge:
                      </label>
                      <input
                        type="text"
                        id="packing_Charge"
                        name="packing_Charge"
                        value={formData.packing_Charge}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            packing_Charge: Number(e.target.value),
                          }))
                        }
                        className="border rounded-md px-2 py-1 w-24 text-right focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-700 font-medium">Total:</span>
                      <strong className="text-lg">₹{total?.toFixed(2)}</strong>
                    </div>

                    <div className="flex justify-between items-center">
                      <label
                        className="text-gray-700 font-medium"
                        htmlFor="gst_Per"
                      >
                        GST (%):
                      </label>
                      <div className="flex items-center space-x-2">
                        <input
                          type="text"
                          id="gst_Per"
                          name="gsT_Per"
                          value={formData.gsT_Per}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              gsT_Per: Number(e.target.value),
                            }))
                          }
                          className="border rounded-md px-2 py-1 w-24 text-right focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                        />
                        <span>= ₹{gstAmount?.toFixed(2)}</span>
                      </div>
                    </div>

                    <div className="border-t pt-3 mt-4 flex justify-between items-center">
                      <span className="text-xl font-bold">Grand Total:</span>
                      <strong className="text-xl text-primary">
                        ₹{grandTotal?.toFixed(2)}
                      </strong>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white rounded-lg shadow-md mt-6">
                  <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                    <h2 className="text-base font-semibold text-[#405189]">
                      Notes
                    </h2>
                  </div>
                  <div className="p-2 pace-y-4">
                    <label className="text-md">Remarks</label>
                    <textarea
                      id="remark"
                      rows="4"
                      name="remark"
                      value={formData.remark}
                      onChange={handleInputChange}
                      className="mt-2 block w-full rounded border border-gray-300 px-4 py-2 shadow-sm focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                      placeholder="Enter your remarks..."
                    ></textarea>
                  </div>
                </div>
                <div
                  className={`${
                    formData.stageId === 3
                      ? "bg-white rounded-lg shadow-md p-6 space-y-4 mt-6"
                      : "hidden"
                  }`}
                >
                  {shouldShowCloseLostReason(Number(formData.stageId)) && (
                    <>
                      <label className="block text-md font-medium mb-1">
                        Reason
                      </label>
                      <textarea
                        name="reason"
                        value={formData.reason || ""}
                        onChange={handleInputChange}
                        rows="4"
                        className="block w-full rounded-md border border-gray shadow-sm py-2 px-3 resize-y break-words"
                        placeholder="Enter reason here..."
                      ></textarea>
                    </>
                  )}
                </div>
              </div>
              <div className="flex gap-4 mt-6">
                {(isEditing ? permission.isUpdate : permission.isInsert) && (
                  <button
                    className="px-6 py-2 border border-transparent text-sm font-medium rounded text-white bg-primary"
                    type="submit"
                  >
                    {isEditing ? "Update" : "Save"}
                  </button>
                )}
                {isEditing && (
                  <button
                    className="px-4 py-2 border border-transparent text-sm font-medium rounded text-white bg-primary"
                    onClick={() => handlePrint(formData.proforma_No)}
                  >
                    Print
                  </button>
                )}
                <button
                  type="button"
                  className="px-6 py-2 border border-gray text-sm font-medium rounded bg-white"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>
              </div>
            </form>

            <Model
              isOpen={isModelOpen}
              onClose={() => setIsModelOpen(false)}
              name="Add Customer"
            >
              <FormFields
                onSubmit={handleSubmit}
                setIsModelOpen={setIsModelOpen}
                formData={formData}
                handleInputChange={handleInputChange}
                fields={fields}
                onClear={onClear}
              />
            </Model>
            <Model
              isOpen={coatingPartyModel}
              onClose={() => {
                setCoatingPartyModel(false);
                setIsCoatingPartyEditing(false);
              }}
              name={isEditing ? "Edit Coating Party" : "Add Coating Party"}
            >
              <FormFields
                formData={formData}
                fields={CoatingPartyfields}
                handleInputChange={handleInputChange}
                setIsModelOpen={setCoatingPartyModel}
                onClear={() => {
                  setCoatingPartyModel(false);
                  setIsCoatingPartyEditing(false);
                }}
                onSubmit={
                  isCoatingPartyEditing
                    ? handleUpdateCoatingParty
                    : handleCoatingPartySubmit
                }
                isEditing={isCoatingPartyEditing}
              />
            </Model>
          </>
        )}
      </div>
    </>
  );
};

export default FinsMaterialDetails;
